export class UserMessages{
    public static readonly EMAIL_REQUIRED = "O campo Email é necessário.";
    public static readonly EMAIL_INVALID = "Email inválido.";
    public static readonly PASSWORD_REQUIRED = "O campo Senha é necessário.";
    public static readonly CREDENTIALS_INVALID = "Credenciais Inválidas.";
    public static readonly PROFESSIONAL_NAME_REQUIRED = "O campo Nome do Profissional é necessário.";
    public static readonly ORGANIZATION_NAME_REQUIRED = "O campo Nome da Organização é necessário.";
    public static readonly GENERIC_ERROR = "Ocorreu um erro! Verifique sua conexão.";
    public static readonly NO_ORGANIZATION = "Este usuário não possui uma organização.";
    public static readonly PERMISSION_DENIED = "Este usuário não possui permissão para logar no sistema.";
}
